import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AmoLivraisonsServiceOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    text: "+ 6000 logements livrés depuis 2008"
  }, {
    text: "+ 15 partenaires promoteurs locaux et nationaux"
  }, {
    text: "Jusqu'à 5 équipes disponibles simultanément"
  }, {
    text: "3 grandes régions régulièrement visitées (Aura, Paca, Bourgogne)"
  }];
  return <section id="amo-livraisons-service-overview" ref={ref} className="w-full bg-background transition-opacity duration-700 opacity-100 translate-y-0 ![padding:0px_0px_50px_0px]">
      {}
      <div className="relative w-full h-[300px] md:h-[650px] mb-12 overflow-hidden shadow-xl">
        <img src="https://nsdb.10web.cloud/wp-content/uploads/2026/03/NUM0098-scaled.jpg" alt="Modern residential building in Lyon managed by AMO Livraisons" className={`absolute inset-0 w-full object-cover !h-[650px] transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} />
        <div className={`absolute inset-0 bg-black/40 flex items-center justify-center text-center px-4 transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
          <div className="max-w-4xl space-y-4">
            <h2 className={`text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white font-sans drop-shadow-lg transition-all duration-1000 ease-out delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>AMO <span data-ast-id="f:/src/pages/AMOLivraisons2/sections/AmoLivraisonsServiceOverview.tsx|sig:ihtchp" data-ast-start="1549" data-ast-end="1709">Livraisons<br /><br /></span><div className="w-24 h-1.5 bg-primary mx-auto rounded-full" data-ast-id="f:/src/pages/AMOLivraisons2/sections/AmoLivraisonsServiceOverview.tsx|sig:l6jt0p" data-ast-start="1709" data-ast-end="1912"></div><br />Expertise et partenaire de confiance</h2>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="flex flex-col space-y-6">
            <p className="text-lg text-muted-foreground leading-relaxed !not-italic !font-normal">Lors des missions AMO Livraisons, NSDB accompagne les promoteurs immobiliers dans la phase cruciale de la livraison.&nbsp;&nbsp;<br />Avec une large gamme de prestations proposées à la carte et forts de nos 18 ans d'expérience dans ce type de missions, nous assurons une gestion technique et relationnelle irréprochable et complète pour garantir la satisfaction totale de vos acquéreurs et la sérénité de vos équipes.</p>

            <div className="pt-4">
              <Button asChild size="lg" className="bg-accent hover:bg-accent/90 text-accent-foreground shadow-md transition-all hover:scale-105">
                <Link to="#">
                  Nos prestations AMO Livraisons
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>

          <div className="bg-muted/30 rounded-2xl border border-border ![padding:16px_32px_16px_32px]">
            <h3 className="text-xl font-semibold mb-6 text-foreground">Nos chiffres clés</h3>
            <ul className="space-y-4">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <div className="mt-1 bg-primary/10 p-1 rounded-full">
                    <Check className="w-4 h-4 text-primary" />
                  </div>
                  <span className="text-foreground font-medium">{feature.text}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}